<template>
  <v-dialog v-model="isActive" width="800">
    <v-card>
      <v-toolbar dense color="primary" :dark="true">
        <v-toolbar-title>Errores de Tareas</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div>
        <v-data-table
          :headers="headers"
          :items="errorsList"
          :loading="loading"
          item-key="callid"
          style="width: 100%;"
        >
        </v-data-table>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    errorsList: Object,
    isActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data: () => ({
    selectStorage: "",
    headers: [
      { text: "Tipo", value: "type", sortable: "false" },
      { text: "Mensaje", value: "message", sortable: "true" },
    ],
  }),
  methods: {
    closeModal() {
      this.resetVariables();
      this.isActive = false;
      this.$emit("close");
    },
    resetVariables() {
      this.errorsList = "";
    },
  },
  computed: {},
};
</script>

<style></style>
